import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {useEffect, useState} from 'react'
import {useRouter} from 'next/router'
import type {Block} from '@/services/kontent-ai/types'

export type BazaarVoiceRatingsContentItem = IContentItem<{
	productId: Elements.TextElement
}>

export const BazaarVoiceRatingsBlock: Block<BazaarVoiceRatingsContentItem> = ({
	block,
}) => {
	const router = useRouter()
	const [productId, setProductId] = useState(block.elements.productId)

	useEffect(() => {
		const sku =
			typeof router.query.sku === 'string' ? router.query.sku : undefined
		setProductId(sku || block.elements.productId)
	}, [router.query.sku, block.elements.productId])
	return (
		<div
			data-bv-product-id={productId}
			data-bv-show="rating_summary"
			data-kontent-element-codename="product_id"
		/>
	)
}
